var exports = {
  "t": "PageDivider__1DsvHU",
  "q": "PageDividerWrapper__62YMjM",
};

module.exports = exports;
